<script>
export default {
    name: "InventoryStockPriceAdjustment",

    data() {
        return {
            showModal: false,
            transfers: [],
            stockTransferLineItem: [],
            confirmationDialog: false,
            declineDialog: false,
            description: ''
        };
    },
    components: {

        "confirm-approval" : () => import('./modals/ConfirmTransferApproval.vue'),
        "confirm-decline": () => import('./modals/DeclineTransferApproval.vue'),
    },
    mounted() {
        this.fetchPending();
    },

    methods: {
        fetchPending() {
            this.$root.loading = true;

            this.$accountsHttp.get('StockTransfer/PendingPostedStockTranfer').then(response => {
                this.$root.loading = false;
                this.transfers = response.data;
            }).catch(() => this.$root.loading = false);
        },

        confirmApproval() {
            if(this.validateCheckedItems()) return;

            this.confirmationDialog = !this.confirmationDialog;
        },
    
        confirmDecline() {
            if(this.validateCheckedItems()) return;

            this.declineDialog = !this.declineDialog;
        },

        validateCheckedItems() {

            if(this.stockTransferLineItem.length) {

                return false;
            }

            window.Swal.fire({ text: 'At least one item should be checked', type: 'error', showCancelButton: false });

            return true;
        },

        refreshData() {
             this.confirmationDialog = false;
             this.declineDialog = false;
             this.stockTransferLineItem = [];
            this.fetchPending();
        },
    }
}
</script>

<template>
<div class="w-full flex flex-wrap mt-px">
    <div class="w-full overflow-auto">
        <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="flex w-full">
                    <td class="p-tiny w-1/12">Code</td>
                    <td class="p-tiny w-1/6">Name</td>
                    <td class="p-tiny w-1/12">Transfercode</td>
                    <td class="p-tiny w-1/6">From</td>
                    <td class="p-tiny w-1/6">To</td>
                    <td class="p-tiny w-1/12">Qty</td>
                    <td class="p-tiny w-1/12">Date</td>
                    <td class="p-tiny w-1/6">Username</td>
                    <td class="p-tiny w-1/12">Action</td>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs overflow-auto bg-gray-100" style="height:60vh;">
                <tr class="w-full flex" v-for="(transfer, idx) in transfers" :key="idx">
                    <td class="p-tiny w-1/12">{{ transfer.itemID }}</td>
                    <td class="p-tiny w-1/6">{{ transfer.itemName }}</td>
                    <td class="p-tiny w-1/12">{{ transfer.transfercode }}</td>
                    <td class="p-tiny w-1/6">{{ transfer.storeFrom }}</td>
                    <td class="p-tiny w-1/6">{{ transfer.storeTo }}</td>
                    <td class="p-tiny w-1/12">{{ transfer.qty }}</td>
                    <td class="p-tiny w-1/12">{{ transfer.date | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ transfer.userName || `-` }}</td>
                    <td class="p-tiny w-1/12">
                        <input class="leading-tight" 
                            :value="{
                                itemId : transfer.itemID,
                                userName: transfer.userName,
                                description: description,
                                itemName: transfer.itemName,
                                transferCode: transfer.transfercode
                            }"
                            v-model="stockTransferLineItem"
                            type="checkbox" checked>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <confirm-approval :showModal="confirmationDialog" :stockTransferLineItem="stockTransferLineItem" @refreshPage="refreshData" @closeModal="confirmationDialog=!confirmationDialog"/>
    <confirm-decline :showModal="declineDialog" :stockTransferLineItem="stockTransferLineItem" @refreshPage="refreshData" @closeModal="declineDialog=!declineDialog"/>
    <div class="w-full flex">
        <div class="flex-1 justify-start">
            <label class="label-control" for="description">Description:</label>
            <textarea id="description" v-model="description" cols="30" rows="2" class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="flex-1 mt-3">
            <div class="flex justify-end">
                <button class="btn-danger btn-sm text-xs rounded mr-4" @click.prevent="confirmDecline"><i class="fa fa-times"></i> Decline</button>
                <button class="btn-primary btn-sm text-xs rounded" @click.prevent="confirmApproval"><i class="fa fa-check"></i> Approve</button>
            </div>
        </div>
    </div>
</div>
    
</template>
